import { Navigate } from "react-router-dom";
import { useContext, ReactElement } from "react";
import { AuthContext } from "../context/AuthContext";

type Props = { children: ReactElement };

export default function PrivateRoute({ children }: Props): ReactElement {
  const { state } = useContext(AuthContext);
  if (!state.isLoggedIn) {
    try {
      sessionStorage.setItem("authRedirectMessage", "로그아웃 되었습니다.");
    } catch {}
    return <Navigate to="/login" replace />;
  }
  return children;
}